<template>
  <v-tooltip v-if="date" location="top">
    <template #activator="{ props: tooltipProps }">
      <span v-bind="tooltipProps" class="cursor-help">{{ timeAgo }}</span>
    </template>
    <span>{{ formatAbsoluteDate(date) }}</span>
  </v-tooltip>
  <span v-else class="text-grey">—</span>
</template>

<script lang="ts" setup>
import { formatTimeAgoIntl, useNow } from '@vueuse/core'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import dayjs from 'dayjs/esm'
import { addMissingTimezoneUTC } from '~/helper/date'

const props = defineProps<{
  date?: string | null
}>()

const i18n = useI18n()
const now = useNow({ interval: 1000 })
const normalizedDate = computed(() => addMissingTimezoneUTC(props.date) || null)
const timeAgo = computed(() => {
  const currentTime = now.value
  if (!normalizedDate.value) {
    return ''
  }
  void currentTime
  return formatTimeAgoIntl(new Date(normalizedDate.value), { locale: i18n.locale.value })
})

function formatAbsoluteDate(dateString: string): string {
  return dayjs(addMissingTimezoneUTC(dateString)).format('DD.MM.YYYY HH:mm')
}
</script>
